import { Toolbar } from '@mui/x-data-grid-pro';
import ExportButton from './Actions/ExportButton';
import { StyledQuickFilter } from '../StyledComponents';

import styles from './DataGrid.Dispatch.module.css';

/**
 * Toolbar that sits on top of the Research (Dispatch) Board and displays form fields for searching.
 */
export default function ResearchGridToolbar() {
  return (
    <Toolbar>
      <ExportButton
        name='Research'
        disabled={false}
      />
      <StyledQuickFilter className={styles['research-quick-filter']} />
    </Toolbar>
  );
}
